import styled from '@emotion/styled'

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`
